export default "__VITE_ASSET__$ADmU8gv__"